//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  required, integer, minValue, decimal, requiredIf, maxLength, minLength, email
} from 'vuelidate/lib/validators'
import InputGroup from '@/components/form/InputGroup.vue'
import WysiwygTextareaGroup from '@/components/form/WysiwygTextareaGroup.vue'
import LoadingButton from '@/components/ui/LoadingButton.vue'
import richTextMinCharacters from '@/validations/richTextMinCharacters'
import richTextMaxCharacters from '@/validations/richTextMaxCharacters'
import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'
import { taskLocations, taskPriceTypes, taskTypes } from 'ct-constants'
import CategorySkillSelector from '@/components/form/CategorySkillSelector'
import BecomeTrusted from '@/components/client/BecomeTrusted'
import Captcha from '@/mixins/Captcha'
import HCaptchaInput from '@/components/form/HCaptchaInput'

// TODO add attachments uploader

const initialForm = {
  title: null,
  description: '',
  price: null,
  duration: null,
  published: false,
  attachments: [],
  negotiablePrice: false,
  negotiableDuration: false,
  type: taskTypes.ONETIME,
  location: taskLocations.REMOTE,
  priceType: 'fixed',
  currencyId: null,
  requireResume: false,
  client: {
    email: '',
    avatar: null,
    name: null,
    about: null
  },
  token: null
}

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'TaskForm',
  components: {
    HCaptchaInput,
    BecomeTrusted,
    CategorySkillSelector,
    LoadingButton,
    WysiwygTextareaGroup,
    InputGroup
  },
  mixins: [AxiosErrorHandler, Captcha],
  props: {
    title: {
      type: String,
      default: ''
    },
    task: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      form: Object.assign({}, initialForm),
      sending: false,
      avatarOptions: {
        resize: {
          width: 240,
          height: 240
        }
      }
    }
  },
  computed: {
    disputedPrice () {
      if (this.form.price !== undefined) {
        return Math.round(this.form.price / 100 * 10)
      }

      return ''
    },

    /**
     * Task types for dropdown
     * @returns {{text: *, value: *}[]}
     */
    types () {
      return Object.values(taskTypes).map(t => ({
        value: t,
        text: this.$t(`tasks.form.${t}`)
      }))
    },

    /**
     * Task locations for dropdown
     * @returns {{text: *, value: *}[]}
     */
    locations () {
      return Object.values(taskLocations).map(t => ({
        value: t,
        text: this.$t(`tasks.form.${t}`)
      }))
    },

    /**
     * Is price negotiable
     */
    isPriceNegotiable () {
      return this.form.negotiablePrice
    },

    /**
     * Is duration negotiable
     */
    isDurationNegotiable () {
      return this.form.negotiableDuration
    },

    priceTypeOptions () {
      if (this.form.type === taskTypes.PARTTIME || this.form.type === taskTypes.FULLTIME) {
        return [
          {
            value: taskPriceTypes.HOURLY,
            text: this.$t(`tasks.form.${taskPriceTypes.HOURLY}`)
          },
          {
            value: taskPriceTypes.MONTHLY,
            text: this.$t(`tasks.form.${taskPriceTypes.MONTHLY}`)
          },
          {
            value: taskPriceTypes.YEARLY,
            text: this.$t(`tasks.form.${taskPriceTypes.YEARLY}`)
          }
        ]
      } else if (this.form.type === taskTypes.ONETIME) {
        return [
          {
            value: taskPriceTypes.HOURLY,
            text: this.$t(`tasks.form.${taskPriceTypes.HOURLY}`)
          },
          {
            value: taskPriceTypes.FIXED,
            text: this.$t(`tasks.form.${taskPriceTypes.FIXED}`)
          }
        ]
      }

      return []
    },

    /**
     * Array of currencies for select dropdown
     */
    currencies () {
      return this.$store.state.util.currencies.map(c => ({
        value: c.id,
        text: c.code
      }))
    },

    defaultCurrency () {
      return this.$store.getters['util/getDefaultCurrency']
    },

    /**
     * Checks if current user is logged in
     */
    isLoggedIn () {
      return this.$auth.loggedIn
    },

    /**
     * Is used for editing or creating task
     */
    isEdit () {
      return !!this.task?.id
    },

    /**
     * Get array of languages mapped for select input
     */
    languages () {
      return this.$store.getters['util/getEnabledLanguages'].map(l => ({
        value: l.id,
        text: l.name
      }))
    }
  },
  watch: {
    /**
     * Set task if editing
     * @param {Object} nv
     */
    task (nv) {
      if (nv) {
        this.form = { ...this.task }
      }
    },
    /**
     * Set default currency if not already set
     * @param nv
     */
    defaultCurrency (nv) {
      if (!this.form.currencyId && nv) {
        this.form.currencyId = nv.id
      }
    }
  },
  mounted () {
    if (this.task) {
      this.form = { ...this.task }
    }

    if (!this.form.currencyId && this.defaultCurrency) {
      this.form.currencyId = this.defaultCurrency.id
    }
  },
  validations () {
    const v = {
      form: {
        title: {
          required,
          maxLength: maxLength(100)
        },
        description: {
          required,
          richTextMinCharacters: richTextMinCharacters(150),
          richTextMaxCharacters: richTextMaxCharacters(5000)
        },
        price: {
          required,
          decimal,
          minValue: minValue(1)
        },
        priceType: {
          required
        },
        duration: {
          // eslint-disable-next-line func-names
          required: requiredIf(function () {
            return !this.isDurationNegotiable
          }),
          integer
        },
        categories: {
          required,
          minLength: minLength(1)
        },
        skills: {
          required,
          minLength: minLength(1)
        },
        client: {
          email: {
            // eslint-disable-next-line func-names
            required: requiredIf(function () {
              return !this.isLoggedIn
            }),
            email
          },
          name: {
            // eslint-disable-next-line func-names
            required: requiredIf(function () {
              return !this.isLoggedIn
            }),
            maxLength: maxLength(50)
          },
          about: {
            // eslint-disable-next-line func-names
            required: requiredIf(function () {
              return !this.isLoggedIn
            }),
            richTextMinCharacters: richTextMinCharacters(50),
            richTextMaxCharacters: richTextMaxCharacters(5000)
          }
        }
      }
    }

    if (!this.isDurationNegotiable) {
      v.form.duration.minValue = minValue(1)
    }

    return v
  },
  methods: {
    async submitForm () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        if (!this.task?.id) {
          // create task
          await this.createTask()
        } else {
          // update existing task
          await this.updateTask()
        }
      }
    },

    /**
     * Create new task
     */
    async createTask () {
      try {
        this.sending = true

        this.form = Object.assign({}, this.form, {
          languageId: this.$store.getters['util/getCurrentLanguage'].id
        })

        const newTask = await this.$store.dispatch('tasks/create', this.form)

        // register bc data
        this.$smartContract.setTaskProperties(newTask, this.$store.state.i18n.locale)
          .then(async (bcTask) => {
            console.log(bcTask)
            try {
              const resBc = await this.$axios.put('/tasks/regBcTask', bcTask)
              console.log(resBc.data)
            } catch (err) {
              console.error(err.response ? err.response.data : err)
            }
          })
          .catch(e => console.log(e))

        // reset form
        this.form = { ...initialForm }

        // reset validation
        this.$v.$reset()

        let successMessage = this.isLoggedIn
          ? this.$t('tasks.form.success_notification')
          : this.$t('tasks.form.success_anon_notification')

        if (newTask.published) {
          successMessage = this.$t('tasks.form.successPublished')
        }

        await this.$store.dispatch('ui/showNotification', {
          type: 'success',
          text: successMessage,
          expiry: 10000
        })

        this.$gtag.event('created_task', {
          id: newTask.id
        })

        this.$emit('created', newTask)

        this.sending = false
      } catch (err) {
        await this.handleError(err)
        this.sending = false
      }
    },

    /**
     * Update task data
     */
    async updateTask () {
      try {
        this.sending = true
        const taskData = await this.$store.dispatch('tasks/update', {
          id: this.task.id,
          taskData: this.form
        })

        // register update to bc
        this.$smartContract.setEditTaskProperties(taskData)
          .then(async (bcTask) => {
            console.log(bcTask)
            try {
              const resBc = await this.$axios.put('/tasks/regBcEditTask', bcTask)
              console.log(resBc.data)
            } catch (err) {
              console.error(err.response ? err.response.data : err)
            }
          })
          .catch(e => console.log(e))

        await this.$store.dispatch('ui/showNotification', {
          type: 'success',
          text: this.$t('tasks.form.updateSuccess')
        })
        this.sending = false
      } catch (err) {
        this.sending = false
        await this.handleError(err)
      }
    },

    /**
     * Attach files to form
     * @param files
     */
    attach (files) {
      this.form.attachments = files
    },

    /**
     * Set default price type per job type
     */
    defaultPriceType () {
      switch (this.form.type) {
        case taskTypes.ONETIME:
          this.form.priceType = taskPriceTypes.FIXED
          break
        case taskTypes.PARTTIME:
          this.form.priceType = taskPriceTypes.HOURLY
          break
        case taskTypes.FULLTIME:
          this.form.priceType = taskPriceTypes.MONTHLY
          break
      }
    },

    avatarAdded (data) {
      this.form.client.avatar = data
    },

    avatarRemoved () {
      this.form.client.avatar = null
    },

    updatedTags (e) {
      this.form = { ...this.form, ...e }
    }
  }
}
